import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import { PersistGate } from 'redux-persist/integration/react';

import configureStore from './configureStore';
import GraphQLClient from '@api/graphql/GraphQLClient';
import App from './App';

import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app


const { store, persistor } = configureStore();

ReactDOM.render(
    <PersistGate persistor={persistor}>
        <Provider store={store}>
            <ApolloProvider client={GraphQLClient}>
                <App store={store} />
            </ApolloProvider>
        </Provider>
    </PersistGate>,
    document.getElementById('root') as HTMLElement,
);



// WEBPACK FOOTER //
// ./src/index.tsx